<template>
  <div 
    class="standard-pagination bg-white flex flex-end items-center"
    :style="{
      paddingTop: typeof paddingTop === 'number' ? paddingTop + 'px' : paddingTop,
      paddingBottom: typeof paddingBottom === 'number' ? paddingBottom + 'px' : paddingBottom
    }"
  >
    <div v-if="showTotal" class="pagination-info flex items-center">
      <span class="total-text text-12 color-label">共 {{ total }} 条</span>
    </div>
    <el-pagination
      :current-page="currentPage"
      :page-size="pageSize"
      :total="total"
      :page-sizes="pageSizes"
      :layout="layout"
      :background="false"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      class="pagination-controls custom-pagination"
    />
  </div>
</template>

<script>
export default {
  name: 'StandardPagination',
  props: {
    // 当前页码
    currentPage: {
      type: Number,
      default: 1
    },
    // 每页条数
    pageSize: {
      type: Number,
      default: 10
    },
    // 总条数
    total: {
      type: Number,
      default: 0
    },
    // 每页条数选项
    pageSizes: {
      type: Array,
      default: () => [50, 100, 200, 300, 400, 500, 1000]
    },
    // 分页布局
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    // 是否显示总数信息
    showTotal: {
      type: Boolean,
      default: true
    },
    // 顶部内边距
    paddingTop: {
      type: [String, Number],
      default: 32
    },
    // 底部内边距
    paddingBottom: {
      type: [String, Number],
      default: 24
    }
  },
  methods: {
    // 每页条数变化
    handleSizeChange(val) {
      this.$emit('size-change', val)
    },
    // 当前页变化
    handleCurrentChange(val) {
      this.$emit('current-change', val)
    }
  }
}
</script>

<style>
/* 全局样式，不使用scoped */
.custom-pagination .el-pager li {
  min-width: 32px !important;
  height: 32px !important;
  line-height: 30px !important;
  margin: 0 4px !important;
  border: 1px solid rgba(235, 238, 245, 1) !important;
  border-radius: 2px !important;
  background: #fff !important;
  color: rgba(48, 49, 51, 1) !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  transition: all 0.3s !important;
}

.custom-pagination .el-pager li:hover {
  color: rgba(42, 117, 247, 1) !important;
  border-color: rgba(42, 117, 247, 1) !important;
}

.custom-pagination .el-pager li.active {
  background: rgba(42, 117, 247, 1) !important;
  border-color: rgba(42, 117, 247, 1) !important;
  color: #fff !important;
}

.custom-pagination .el-pager li.active:hover {
  background: rgba(42, 117, 247, 1) !important;
  border-color: rgba(42, 117, 247, 1) !important;
  color: #fff !important;
}

.custom-pagination .btn-prev,
.custom-pagination .btn-next {
  min-width: 32px !important;
  height: 32px !important;
  line-height: 30px !important;
  margin: 0 4px !important;
  border: 1px solid rgba(235, 238, 245, 1) !important;
  border-radius: 2px !important;
  background: #fff !important;
  color: rgba(0, 0, 0, 0.9) !important;
  font-size: 12px !important;
  transition: all 0.3s !important;
}

.custom-pagination .btn-prev:hover,
.custom-pagination .btn-next:hover {
  color: rgba(42, 117, 247, 1) !important;
  border-color: rgba(42, 117, 247, 1) !important;
}

.custom-pagination .btn-prev:disabled,
.custom-pagination .btn-next:disabled {
  color: #c0c4cc !important;
  border-color: #ebeef5 !important;
  background: #f5f7fa !important;
  cursor: not-allowed !important;
}

.custom-pagination .el-pager li.more {
  background: #fff !important;
  border: 1px solid rgba(235, 238, 245, 1) !important;
  color: rgba(48, 49, 51, 1) !important;
  cursor: default !important;
}

.custom-pagination .el-pager li.more:hover {
  color: rgba(48, 49, 51, 1) !important;
  border-color: rgba(235, 238, 245, 1) !important;
  background: #fff !important;
}
.custom-pagination .el-input--mini .el-input__inner{
  height: 32px;
  line-height: 30px;
}
</style>

<style scoped>
.pagination-controls {
  display: flex;
  align-items: center;
}

/* 每页条数选择器样式 */
.pagination-controls .el-pagination .el-pagination__sizes {
  margin-right: 20px;
}

.pagination-controls .el-pagination .el-pagination__sizes .el-input {
  width: 80px;
}

.pagination-controls .el-pagination .el-pagination__sizes .el-input__inner {
  height: 32px;
  line-height: 30px;
  border: 1px solid rgba(235, 238, 245, 1);
  border-radius: 2px;
  font-size: 14px;
  text-align: center;
  color: rgba(48, 49, 51, 1);
  background: #fff;
  transition: all 0.3s;
}

.pagination-controls .el-pagination .el-pagination__sizes .el-input__inner:hover {
  border-color: rgba(42, 117, 247, 1);
}

.pagination-controls .el-pagination .el-pagination__sizes .el-input__inner:focus {
  border-color: rgba(42, 117, 247, 1);
  box-shadow: 0 0 0 2px rgba(42, 117, 247, 0.1);
}

.pagination-controls .el-pagination .el-pagination__sizes .el-input__suffix {
  right: 8px;
}

.pagination-controls .el-pagination .el-pagination__sizes .el-input__suffix .el-input__icon {
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
}

/* 跳转输入框样式 */
.pagination-controls .el-pagination .el-pagination__jump {
  margin-left: 20px;
}

.pagination-controls .el-pagination .el-pagination__jump .el-input {
  width: 60px;
}

.pagination-controls .el-pagination .el-pagination__jump .el-input__inner {
  height: 32px;
  line-height: 30px;
  border: 1px solid rgba(235, 238, 245, 1);
  border-radius: 2px;
  font-size: 14px;
  width: 50px;
  text-align: center;
  color: rgba(48, 49, 51, 1);
  background: #fff;
  transition: all 0.3s;
}

.pagination-controls .el-pagination .el-pagination__jump .el-input__inner:hover {
  border-color: rgba(42, 117, 247, 1);
}

.pagination-controls .el-pagination .el-pagination__jump .el-input__inner:focus {
  border-color: rgba(42, 117, 247, 1);
  box-shadow: 0 0 0 2px rgba(42, 117, 247, 0.1);
}

.pagination-controls .el-pagination .el-pagination__jump .el-pagination__editor {
  margin: 0 8px;
  font-size: 14px;
  color: rgba(48, 49, 51, 1);
}

/* 总数信息样式 */
.pagination-controls .el-pagination__total {
  margin-right: 20px;
  font-size: 14px;
  color: #606266;
  font-weight: 400;
}
</style>
